import { Typography, Divider } from '@mui/material'
import TableMui from 'src/components/TableMui'
import * as S from './ErrorLog.style'

interface Column {
  id: string
  label: string
}

interface Row {
  [key: string]: string;
}

interface ErrorLogProps {
  label: string
  columns: Column[]
  rows: Row[]
  width: string
  height?: string
  enablePagination?: boolean
}

const ErrorLog = ({
  columns, rows, label, width, height, enablePagination = true,
}: ErrorLogProps) => (
  <S.Container width={width}>
    <S.Title>
      <Typography sx={{ fontWeight: 'bold' }}>{ label }</Typography>
      <Divider />
    </S.Title>
    <TableMui
      columns={columns}
      rows={rows}
      enablePagination={enablePagination}
      rowsPerPageLimit={10}
      flatTable
      thinLine
      width='100%'
      maxHeight={height}
      minHeight={height}
      testId='error-log-table-test-id'
    />
  </S.Container>
)

export default ErrorLog
